var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0",
              attrs: { cols: "12", id: "main_content_maxwidthset" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: {
                    align: "center",
                    justify: "space-between",
                    id: "header_height",
                  },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: {
                                color: "#08B0FF",
                                "font-size": "1rem",
                              },
                              attrs: {
                                id: "back_clean_btn",
                                width: "6rem",
                                height: "50px",
                                elevation: "0",
                              },
                              on: { click: _vm.goCameraStatus },
                            },
                            [_vm._v(" " + _vm._s(_vm.tc("headerTitle")) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c("v-img", {
                        staticClass: "ma-0 pa-0 mr-3",
                        attrs: {
                          "max-height": "50px",
                          "max-width": "1.5rem",
                          src: require("@/assets/images/history_arrow.png"),
                        },
                      }),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.tc("headerMaintenance")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { "font-size": "0.9rem" },
                              attrs: {
                                id: "blue_btn",
                                width: "10rem",
                                height: "2rem",
                                elevation: "0",
                              },
                              on: { click: _vm.requestSave },
                            },
                            [_vm._v(" " + _vm._s(_vm.tc("save")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: {
            id: "main_content_maxwidthset",
            cols: "12",
            align: "center",
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 pt-9", attrs: { cols: "10" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 setting_btn",
                  attrs: { id: "setting_btn1", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-4",
                      attrs: { align: "center", justify: "space-between" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                        [_vm._v(_vm._s(_vm.tc("faceRecoqThreshold")))]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0 pr-3", attrs: { cols: "2" } },
                        [
                          _c("v-select", {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              items: _vm.thresholdList,
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              dark: "",
                              "item-text": "label",
                              "item-value": "value",
                            },
                            model: {
                              value: _vm.selectedThreshold,
                              callback: function ($$v) {
                                _vm.selectedThreshold = $$v
                              },
                              expression: "selectedThreshold",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }